export const mutateFieldsKeys = {
  createUpdateFieldTranslations: ['createUpdateFieldTranslations'] as const,
  loadFieldValues: ['loadFieldValues'] as const,
  loadFieldValuesFromFile: ['loadFieldValuesFromFile'] as const
};
